exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-modules-user-screens-___styles__inner___m6e8e {\n  width: 20em;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap; }\n", ""]);

// Exports
exports.locals = {
	"inner": "src-modules-user-screens-___styles__inner___m6e8e"
};